import { type FC, Fragment, type ReactElement } from 'react';

import { SKELETON_LIST_COUNT } from '@web/constants/app';

type Props = {
  children: ReactElement;
  count?: number;
};

// Renders without a wrapper so the items land directly in the parent's flex or grid layout.
export const SkeletonList: FC<Props> = ({ children, count = SKELETON_LIST_COUNT }) => (
  <>
    {Array.from({ length: count }, (_, index) => (
      <Fragment key={index}>{children}</Fragment>
    ))}
  </>
);
